import {mapActions, mapGetters} from 'vuex'

import {clientMixin} from '@/mixins/clientMixin'

export const campaignMixin = {
  mixins: [clientMixin],
  computed: {
    ...mapGetters({
      'campaigns': 'campaigns/all',
      'clientCampaigns': 'campaigns/clientCampaigns',
      'footageLoadingVal': 'assets/footageLoadingVal',
      'campaign': 'campaigns/campaign'
    })
  },
  methods: {
    ...mapActions({
      'getCampaigns': 'campaigns/getCampaigns',
      'addCampaign': 'campaigns/addCampaign',
      'getCampaign': 'campaigns/getCampaign',
      'updateCampaign': 'campaigns/updateCampaign',
      'deleteCampaign': 'campaigns/deleteCampaign',
      'cloneCampaign': 'campaigns/cloneCampaign',
      'cloneCampaignStatus': 'campaigns/cloneCampaignStatus',
      'getClientCampaigns': 'campaigns/getClientCampaigns'
    })
  },
  data: () => ({
    clientOptions: [],
    steps: {
      options: ['Campaign', 'Creative', 'Fields']
    }
  })
}



// WEBPACK FOOTER //
// ./src/mixins/campaignMixin.js